export default __webpack_public_path__ + "static/helpbox-a753813235272e40804edbaea325cad3.png";